interface FreshChatUserData {
    userId: number;
    project: string;
    firstName: string;
    lastName: string;
}

class FreshChat {
    scriptId = 'freshchat-script';
    token = '';
    tags: Array<string> = [];
    userData: FreshChatUserData | null = null;
    isLoaded = false;
    isOpen = false;
    frameOrigin = "https://wchat.freshchat.com"

    constructor(token: string, userData: FreshChatUserData | null = null, tags: Array<string> = []) {
        this.token = token;
        this.userData = userData;
        this.tags = tags;
        this.init();

        window.addEventListener('message', this.frameMessageHandler.bind(this))
    }

    init() {
        let script: any = document.getElementById(this.scriptId);
        if (!script) {
            script = document.createElement('script');
            script.src = 'https://wchat.freshchat.com/js/widget.js';
            script.async = true;
            script.onload = () => {
                this.initFreshChat();
            }
            script.id = this.scriptId;
            document.head.append(script);
        }
        else {
            this.initFreshChat();
        }
    }

    frameMessageHandler(messageEvent: MessageEvent) {
        if (messageEvent.origin === this.frameOrigin && messageEvent.data.action === "resize_frame") {
            this.isOpen = messageEvent.data.isOpen
        }
    }

    /**
     * Init plugin
     */
    initFreshChat() {
        (window as any).fcWidget.init({
            token: this.token,
            host: "https://wchat.freshchat.com",
            tags: this.tags
        });

        this.isLoaded = true;
        if (this.userData) {
            this.setUserData(this.userData);
        }
    }

    /**
     * Sets excternal id, first name, last name
     * @param data
     */
    setUserData(data: FreshChatUserData) {
        (window as any).fcWidget.setExternalId(`${data.userId}@${data.project}`);
        (window as any).fcWidget.user.setProperties(data);

        if (data && Object.keys(data).length) {
            this.hideIcon();
        }
    }

    /**
     * Maks fresh hat icon hidden
     */
    hideIcon() {
        (window as any).fcWidget.setConfig({
            "headerProperty": {
                "hideChatButton": true
            }
        })
    }

    open() {
        if ((window as any).fcWidget.isOpen() != true) {
            (window as any).fcWidget.open();
        }
    }

    close() {
        if ((window as any).fcWidget.isOpen() == true) {
            (window as any).fcWidget.close();
        }
    }

    destroy() {
        (window as any).fcWidget.destroy();
    }
}

const prepareUserData = (rootState: any): FreshChatUserData => {
    return {
        userId: rootState.session.userId,
        project: rootState.session.backend,
        lastName: rootState.session.profile?.lastName || '',
        firstName: rootState.session.profile?.firstName || '',
    }
}

export {FreshChat, FreshChatUserData, prepareUserData}